import axios from 'axios';

export default {
  FETCH_CUSTOM_TAGS ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('groupdef/loadAllTags')
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_INTERESTS_GROUP ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('interests')
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_EXPERTS_GROUP ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('experts')
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_TRENDING_PLAYLIST_GROUP ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('playlists/getAllCuratedPlaylistsWithVideos')
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_ARTICLES_GROUP ({commit, dispatch}){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get('user/findAllToneArticles')
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_GROUPS ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('groupdef/loadGroupDefinitions')
        .then((response) => {
          const { data: { data : { payload } } } = response;
          localStorage.setItem('groups', JSON.stringify(payload));
          commit('SET_GROUP', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FILTER_GROUPS ({commit, dispatch}, filterText){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.get(`/playlists/searchAlikeTitleVideos/${filterText}`)
        .then((response) => {
          const { data: { data : { payload } } } = response;
          commit('SET_FILTER_RESULTS', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GET_SELECTED_GROUP ({ commit }, groupDefinitionId) {
    commit('TOGGLE_LOADING', true);
    return axios.get(`groupdef/loadGroupDefinitionsById/${groupDefinitionId}`).then((response) => {
      commit('TOGGLE_LOADING', false);
      const { data: { data : { payload }} } = response;
      // let selectedGroup = payload.filter(x => {
      //   return x.groupDefinitionId.toString() === groupDefinitionId.toString()
      // });
      console.log('found group ajx1', payload)
      commit('SET_SELECTED_GROUP', payload)
    }, (err) => {
      commit('TOGGLE_LOADING', false);
      console.log('err ', err)
    })
  },
  ADD_GROUP({commit, dispatch}, payload){
    console.log('add payload', payload)
    if (payload.csvGroupInterestsId && payload.csvGroupInterestsId !== "") {
      payload.csvGroupInterestsId = payload.csvGroupInterestsId.toString()
    } else {
      payload.csvGroupInterestsId = null
    }
    if (payload.csvGroupExpertsId && payload.csvGroupExpertsId !== "") {
      payload.csvGroupExpertsId = payload.csvGroupExpertsId.toString()
    } else {
      payload.csvGroupExpertsId = null
    }
    if (payload.csvGroupArticlesId && payload.csvGroupArticlesId !== "") {
      payload.csvGroupArticlesId = payload.csvGroupArticlesId.toString()
    } else {
      payload.csvGroupArticlesId = null
    }
    if (payload.csvGroupTrendPlaylistId && payload.csvGroupTrendPlaylistId !== "") {
      payload.csvGroupTrendPlaylistId = payload.csvGroupTrendPlaylistId.toString()
    } else {
      payload.csvGroupTrendPlaylistId = null
    }
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      console.log("add group payload : ", payload);
      axios.post('groupdef/insertGroupDefinitions', payload)
        .then((response) => {
          console.log('ADD_GROUP action fetch response : ', response);
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('ADD_GROUP action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_VIDEO_META_DATA({commit, dispatch}, csvVideoCodes){
    console.log('new meta data paylaod', csvVideoCodes )
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/corporations/updateToneDBWithJWData', {csvVideoCodes: csvVideoCodes} )
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_GROUP action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_VIDEO_META_TAGS({commit, dispatch}, payload){
    console.log('new meta tag paylaod', payload )
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/SyncToneAndJWPlayer/updateJWPlayerVideoTags', payload )
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_GROUP action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_GROUP({commit, dispatch}, payload){
    if (payload.csvGroupInterestsId && payload.csvGroupInterestsId !== "") {
      payload.csvGroupInterestsId = payload.csvGroupInterestsId.toString()
    } else {
      payload.csvGroupInterestsId = null
    }
    if (payload.csvGroupExpertsId && payload.csvGroupExpertsId !== "") {
      payload.csvGroupExpertsId = payload.csvGroupExpertsId.toString()
    } else {
      payload.csvGroupExpertsId = null
    }
    if (payload.csvGroupArticlesId && payload.csvGroupArticlesId !== "") {
      payload.csvGroupArticlesId = payload.csvGroupArticlesId.toString()
    } else {
      payload.csvGroupArticlesId = null
    }
    if (payload.csvGroupTrendPlaylistId && payload.csvGroupTrendPlaylistId !== "") {
      payload.csvGroupTrendPlaylistId = payload.csvGroupTrendPlaylistId.toString()
    } else {
      payload.csvGroupTrendPlaylistId = null
    }
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/groupdef/updateGroupDefinitions', payload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_GROUP action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/groups/actions.js